// src/lib/game-mode.ts — in-memory only, re-derived per scene entry, never persisted.
import { MOOD_DELTA_BY_TIER } from '@/lib/constants';

export type GameMode = 'daily' | 'daily-hard' | 'practice';

export interface GameConfig {
  mode: GameMode;
  moodDelta: number;                  // = MOOD_DELTA_BY_TIER[tier]; single read-point
  hideHeatmap: boolean;               // hard: suppress the MENU pre-play card (D1)
  assistEnabled: boolean;
  submitToD1: boolean;                // false for practice
  affectsStreak: boolean;             // false for practice
  writesRecord: boolean;              // false for practice
  shareMarkerCandidate: '🕶️' | null;  // candidate only; actual marker gated on a clean run (§3.5)
}

export interface ResolveConfigInput {
  mode: GameMode;
  tier: 1 | 2 | 3;
  assistEnabled: boolean;
}

// The SINGLE Δ read-point (D3). Pure synchronous constant read — no runtime
// KV/D1 override seam (a non-atomic mid-day Δ source is a seed-divergence risk).
export function resolveMoodDelta(tier: 1 | 2 | 3): number {
  return MOOD_DELTA_BY_TIER[tier];
}

export function resolveGameConfig(i: ResolveConfigInput): GameConfig {
  const moodDelta = resolveMoodDelta(i.tier);
  switch (i.mode) {
    case 'daily':
      return { mode: 'daily', moodDelta, assistEnabled: i.assistEnabled, hideHeatmap: false, submitToD1: true, affectsStreak: true, writesRecord: true, shareMarkerCandidate: null };
    case 'daily-hard':
      return { mode: 'daily-hard', moodDelta, assistEnabled: i.assistEnabled, hideHeatmap: true, submitToD1: true, affectsStreak: true, writesRecord: true, shareMarkerCandidate: '🕶️' };
    case 'practice':
      return { mode: 'practice', moodDelta, assistEnabled: false, hideHeatmap: false, submitToD1: false, affectsStreak: false, writesRecord: false, shareMarkerCandidate: null }; // D4: full-info sandbox
  }
}
